// Mock data for Yung World store

export const storeInfo = {
  name: "Yung World",
  tagline: "THE WORLD IS MINE",
  currency: "GBP",
  freeShippingThreshold: 50,
};

export const announcements = [
  "-WELCOME TO YUNG WORLD-",
  "*NEW T-SHIRTS & HOODIES AVAILABLE NOW!*",
  "*LIMITED EDITION DROP*",
  "*FREE SHIPPING ON ORDERS £50 & UP!*",
];

// Updated navigation
export const navLinks = [
  { name: "HOME", path: "/" },
  { name: "MERCH", path: "/shop" },
  { name: "MY MUSIC", path: "/music" },
  { name: "FAQ'S", path: "/faqs" },
];

// NEW 5 PRODUCT IMAGES
const productImages = {
  globeTeeBlack: "https://customer-assets.emergentagent.com/job_yungworld-store/artifacts/qmrj4foh_Screenshot%202026-01-30%20at%205.27.25%E2%80%AFPM.png",
  globeTeeWhite: "https://customer-assets.emergentagent.com/job_yungworld-store/artifacts/zufi592v_Screenshot%202026-01-30%20at%205.23.02%E2%80%AFPM.png",
  globeHoodieWhite: "https://customer-assets.emergentagent.com/job_yungworld-store/artifacts/m320azf1_Screenshot%202026-01-30%20at%205.26.26%E2%80%AFPM.png",
  globeHoodieBlack: "https://customer-assets.emergentagent.com/job_yungworld-store/artifacts/rulsigyf_Screenshot%202026-01-30%20at%205.25.55%E2%80%AFPM.png",
  worldIsMineHoodieBlack: "https://customer-assets.emergentagent.com/job_yungworld-store/artifacts/hs4z7cxv_Screenshot%202026-01-30%20at%205.26.26%E2%80%AFPM.png",
  // Hero background
  collection2: "https://customer-assets.emergentagent.com/job_yungworld-store/artifacts/zkqs6jes_ChatGPT%20Image%20Jan%2030%2C%202026%2C%2003_50_05%20PM.png",
};

export const heroSlides = [
  {
    id: 1,
    image: productImages.collection2,
    buttonText: "SHOP COLLECTION",
    buttonLink: "/shop",
  },
];

// All 5 products with NEW IMAGES
export const allProducts = [
  {
    id: 1,
    name: 'YUNG WORLD "GLOBE" TEE',
    color: "Black",
    price: 19.99,
    images: [productImages.globeTeeBlack],
    category: "T-Shirts",
    type: "tshirt",
    badge: "BEST SELLER",
    description: "The iconic Yung World globe tee in black. Premium heavyweight cotton with screen printed graphics featuring our signature globe design.",
    sizes: ["S", "M", "L", "XL", "2XL"],
    inStock: true,
  },
  {
    id: 2,
    name: 'YUNG WORLD "GLOBE" TEE',
    color: "White",
    price: 19.99,
    images: [productImages.globeTeeWhite],
    category: "T-Shirts",
    type: "tshirt",
    badge: "BEST SELLER",
    description: "The iconic Yung World globe tee in white. Premium heavyweight cotton with screen printed graphics featuring our signature globe design.",
    sizes: ["S", "M", "L", "XL", "2XL"],
    inStock: true,
  },
  {
    id: 3,
    name: 'YUNG WORLD "GLOBE" HOODIE',
    color: "White",
    price: 39.99,
    images: [productImages.globeHoodieWhite],
    category: "Hoodies",
    type: "hoodie",
    badge: "NEW DROP",
    description: "Premium Yung World globe hoodie in white. Heavyweight fleece with kangaroo pocket and drawstring hood. Features our iconic globe design.",
    sizes: ["S", "M", "L", "XL", "2XL"],
    inStock: true,
  },
  {
    id: 4,
    name: 'YUNG WORLD "GLOBE" HOODIE',
    color: "Black",
    price: 39.99,
    images: [productImages.globeHoodieBlack],
    category: "Hoodies",
    type: "hoodie",
    badge: "NEW DROP",
    description: "Premium Yung World globe hoodie in black. Heavyweight fleece with kangaroo pocket and drawstring hood. Features our iconic globe design.",
    sizes: ["S", "M", "L", "XL", "2XL"],
    inStock: true,
  },
  {
    id: 5,
    name: '"THE WORLD IS MINE" HOODIE',
    color: "Black",
    price: 39.99,
    images: [productImages.worldIsMineHoodieBlack],
    category: "Hoodies",
    type: "hoodie",
    badge: "LIMITED EDITION",
    description: "Make a statement with our signature 'THE WORLD IS MINE' hoodie in black. Premium heavyweight fleece featuring bold typography. Limited edition drop.",
    sizes: ["S", "M", "L", "XL", "2XL"],
    inStock: true,
  },
];

// Collection products for grid display
export const collectionProducts = allProducts.map(product => ({
  id: product.id,
  name: `${product.name} - ${product.color}`,
  price: product.price,
  image: product.images[0],
  hoverImage: product.images[0],
  vendor: "Yung World",
  badge: product.badge,
  color: product.color,
  type: product.type,
}));

export const footerLinks = {
  shop: [
    { name: "All Products", path: "/shop" },
    { name: "T-Shirts", path: "/shop" },
    { name: "Hoodies", path: "/shop" },
    { name: "My Music", path: "/music" },
  ],
  help: [
    { name: "FAQ's", path: "/faqs" },
    { name: "Shipping Info", path: "/shipping" },
    { name: "Returns", path: "/returns" },
    { name: "Contact Us", path: "/contact" },
  ],
  social: [
    { name: "Instagram", url: "https://instagram.com" },
    { name: "Twitter", url: "https://twitter.com" },
    { name: "TikTok", url: "https://tiktok.com" },
  ],
};

export const logoUrl = "https://customer-assets.emergentagent.com/job_bb55f211-fd40-44ac-9e01-bddc4b04c712/artifacts/gp3fdp5r_DEXY%20b.png";
